<template>
  <div class="row">
    <div class="col-12">
      <div class="w-100 d-flex justify-content-end">
        <b-button
          variant="primary"
          @click="postModalOpen"
        >
          {{$t('modal.nameModalPost')}}
        </b-button>
      </div>
    </div>

    <div class="col-12">
      <div class="_table">
        <b-table
          :fields="fields"
          :items="items"
        >

        </b-table>
      </div>
    </div>

    <b-modal
      v-model="postModalBool"
      hide-footer
      hide-header
    >
      <PostModal @onClose="postModalClose" />
    </b-modal>

    <b-pagination
      v-model="pagination.page"
      :total-rows="total"
      :per-page="pagination.pageSize"
      @input="getData"
    ></b-pagination>
  </div>
</template>

<script>
  import {index} from "../../../api/endpoints/driver_payments";
  import PostModal from "./components/postModal.vue"

  export default {
    name: "Driver-Payment",
    components: {
      PostModal
    },
    data() {
      return {
        fields: [
          {key: "id", label: this.$t('table.id.label')},
          {key: "name", label: this.$t('table.name.label')},
        ],
        pagination: {
          page: 1,
          pageSize: 15
        },
        total: 1,
        items: [],
        postModalBool: false,
      }
    },
    methods: {
      getData() {
        index(this.pagination).then( res => {
          this.total = res.data.total;
          this.items = res.data.data;
        })
      },
      postModalOpen() {
        this.postModalBool = true;
      },
      postModalClose() {
        this.postModalBool = false;
        this.getData();
      }
    },
    mounted() {
      this.getData()
    },
  }
</script>